export type ProcessStatus = "ON_CONSTRUCTION" | "PUBLISHED" | "INACTIVE";

export const STATUS_CONFIG: Record<
  ProcessStatus,
  { next: ProcessStatus; label: string }
> = {
  ON_CONSTRUCTION: { next: "PUBLISHED", label: "Aprobar proceso" },
  PUBLISHED: { next: "INACTIVE", label: "Archivar" },
  INACTIVE: { next: "PUBLISHED", label: "Desarchivar" },
};
